import "./checkboxes.scss";
import { ReactComponent as PlusIcon } from "../../assets/icons/Plus.svg";
import { Checkbox, FormControlLabel, Tooltip, Modal, Box, IconButton } from "@mui/material";
import React, {useContext, useState} from "react";
import { IoMdCloseCircleOutline as CloseIcon } from "react-icons/io";
import {IsDarkThemeOnContext} from "../../App";

const CriteriaCards = ({
  optionsAvailable,
  onCheckboxClick,
  selectedIds,
  showCustomButton,
  customButtonName,
  onCustomButtonClick,
  maxSelections,
  isLoading,
  disableCustomButton,
  showModal,
  modalTitle
}) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const isDarkThemeOn = useContext(IsDarkThemeOnContext);

  const handleCardClick = (event) => {
    event.stopPropagation();
    const { name, checked } = event.target;
    onCheckboxClick(name, checked);
  };

  const handleCardSelect = (card) => {
    setSelectedCard(card);
    !!showModal && setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const isPredefinedCriteria = selectedCard && selectedCard.id && selectedCard.id.startsWith('Symbl')

  return (
    <div className={"cards-container"}>
      {showCustomButton && (
        <button className={'card custom-button'} onClick={onCustomButtonClick} disabled={disableCustomButton}>
          <p>{customButtonName}</p>
          <PlusIcon />
        </button>
      )}

      {optionsAvailable.map(({ id, name, description, checklist }) => {
        const disableCardClick = selectedIds.length >= maxSelections && selectedIds.indexOf(id) === -1 || isLoading

        return (<div
            key={id}
            className={`card ${selectedIds.indexOf(id) !== -1 ? 'selected' : ''}`}
            onClick={disableCardClick ? () => {} : () => handleCardSelect({ id, name, description, checklist })}
        >
            <FormControlLabel
              key={id}
              value="start"
              control={<Checkbox style={{ color: "#0075FF" }} onClick={handleCardClick} />}
              label={name}
              name={id}
              checked={selectedIds.indexOf(id) !== -1}
              labelPlacement="start"
              disabled={disableCardClick}
              classes={{root: disableCardClick ? 'disabled-checkbox' : ''}}
            />
            {/* <Tooltip title={description} placement="top"> */}
              <p className="text-description">{description}</p>
            {/* </Tooltip> */}
        </div>)})
      }

      <Modal open={openModal} onClose={handleCloseModal} id={`${isDarkThemeOn ? 'dark-theme-view-criteria' : 'light-theme'}`}>
          <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: 24
            }}>
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title">{modalTitle}</h2>
              <IconButton className="close-button" onClick={handleCloseModal}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="modal-body">
              <div className="modal-section name-section">
                <strong>Name</strong>
                <p>{selectedCard?.name}</p>
              </div>
              <div className="modal-section description-section">
                <strong>Description</strong>
                <div className="description-scrollable">
                  <p>{selectedCard?.description}</p>
                </div>
              </div>
              {selectedCard?.checklist && !isPredefinedCriteria && <div className="modal-section checklist-section">
                <strong>Checklist Questions</strong>
                <div className="checklist-headers">
                  <strong>Questions</strong>
                  <strong>Priority</strong>
                </div>
                <div className="checklist-scrollable">
                  {
                    selectedCard.checklist.map(({question, priority}) => (
                        <div key={question} className="checklist-item">
                          <p>{question}</p>
                          <p className="priority">{priority}</p>
                        </div>
                    ))
                  }
                </div>
              </div>}
          </div>
        </div>
        </Box>
      </Modal>
    </div>
  );
};

export default CriteriaCards;